// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <https://benrichardson.dev>
// Based on QuakeWatch by Ben Richardson — https://benrichardson.dev
import type { Period } from '../types';

export function periodNoun(p: Period): string {
  switch (p) {
    case 'hour': return 'hour';
    case 'day': return 'day';
    case 'week': return '7 days';
    case 'month': return '30 days';
  }
}

export function emptyState(): string {
  return `<div class="state-msg"><div class="big">No earthquakes in this window</div>Widen the time period or lower the magnitude filter.</div>`;
}

/** Depth colour legend swatches used by map + depth views. */
export const DEPTH_LEGEND: Array<{ label: string; color: string }> = [
  { label: '< 35 km', color: '#f87171' },
  { label: '35–70', color: '#fb923c' },
  { label: '70–150', color: '#fbbf24' },
  { label: '150–300', color: '#38bdf8' },
  { label: '300+ km', color: '#6366f1' },
];

export const MAG_LEGEND: Array<{ label: string; color: string }> = [
  { label: '< 2', color: '#22d3ee' },
  { label: '2–3', color: '#4ade80' },
  { label: '3–4', color: '#a3e635' },
  { label: '4–5', color: '#facc15' },
  { label: '5–6', color: '#fb923c' },
  { label: '6–7', color: '#f97316' },
  { label: '7–8', color: '#ef4444' },
  { label: '8+', color: '#c084fc' },
];
